export enum CodingSchemaType {
  NationalPharmaceuticalProductIndex = 'National Pharmaceutical Product Index',
  NationalPharmaceuticalProductAcronym = 'NAPPI',
  NationalPharmaceuticalProductIndexId = 7,

  ReferencePriceList = 'Reference Price List',
  ReferencePriceListAcronym = 'RPL',
  ReferencePriceListId = 10,

  SouthAfricanHospitalRevenueCodes = 'South African Hospital Revenue Codes',
  SouthAfricanHospitalRevenueCodesAcronym = 'SAREV',
  SouthAfricanHospitalRevenueCodesId = 11,

  FuneralServices = 'Funeral Services',
  FuneralServicesAcronym = 'FS',
  FuneralServicesId = 12,

  ManagerOverrideAuthorization = 'Manager Override Authorization',
  ManagerOverrideAuthorizationAcronym = 'MA',
  ManagerOverrideAuthorizationId = 20,

  BenefitBooking = 'Benefit Booking',
  BenefitBookingAcronym = 'AHBB',
  BenefitBookingId = 9,

  SAPROVId = 13
}
